import { Component } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    ImageCdnSrcDirective,
    ImageCdnSrcSetDirective,
} from '@polaris-customerweb/sharedcomponents.shared';

@Component({
    imports: [ImageCdnSrcDirective, ImageCdnSrcSetDirective],
    selector: 'rdx-mobile-app-cta',
    styleUrls: ['./mobile-app-cta.component.scss'],
    templateUrl: './mobile-app-cta.component.html',
})
export class MobileAppCtaComponent {
    appStoreUrl: string;
    brand: string;
    isIndian: boolean;
    isOffRoad: boolean;
    mobileAppPromoDefaultImg: string;
    mobileAppPromoImgSrcSet: string[];
    playStoreUrl: string;

    constructor(configService: ConfigService) {
        if (configService.isIndian) {
            this.mobileAppPromoDefaultImg =
                '/assets/images/shared/mobile-app-cta/indian/ind-go-mobile.png';
            this.mobileAppPromoImgSrcSet = [
                '/assets/images/shared/mobile-app-cta/indian/ind-go-mobile@2x.png 2x',
                '/assets/images/shared/mobile-app-cta/indian/ind-go-mobile@3x.png 3x',
            ];
            this.brand = $localize`Indian Motorcycle`;
        } else if (configService.isSlingshot) {
            this.mobileAppPromoDefaultImg =
                '/assets/images/shared/mobile-app-cta/slingshot/slg-go-mobile.png';
            this.mobileAppPromoImgSrcSet = [
                '/assets/images/shared/mobile-app-cta/slingshot/slg-go-mobile@2x.png 2x',
                '/assets/images/shared/mobile-app-cta/slingshot/slg-go-mobile@3x.png 3x',
            ];
            this.brand = $localize`Polaris Slingshot`;
        } else {
            this.mobileAppPromoDefaultImg =
                '/assets/images/shared/mobile-app-cta/orv/orv-go-mobile.png';
            this.mobileAppPromoImgSrcSet = [
                '/assets/images/shared/mobile-app-cta/orv/orv-go-mobile@2x.png 2x',
                '/assets/images/shared/mobile-app-cta/orv/orv-go-mobile@3x.png 3x',
            ];
            this.brand = $localize`Polaris`;
        }

        this.isIndian = configService.isIndian;
        this.isOffRoad = configService.isOffRoad;
        this.playStoreUrl = configService.appStoreUrl.google;
        this.appStoreUrl = configService.appStoreUrl.apple;
    }
}
